module.exports = __webpack_public_path__ + "img/alert.cc452d1f.svg";